module.exports = __webpack_public_path__ + "img/drmartens_bex-black.0a24b4da.png";